import { createEffect, createStore } from "effector"
import {
  getSharedCommClient,
  importSpecificExportMaybeUndefined,
  initUCS,
} from "../../ucs"
import {
  type LogLevel,
  type Logger,
  type CommClientConfiguration,
  type ICommClient,
} from "@teladoc/ucs-client-react"
import { useStore } from "effector-react"
import { useEffect } from "react"
import { createLogger, updateBaseLogger } from "../../logger"

type CommClientLogOptions = {
  minLevel: LogLevel
  remoteLevel?: LogLevel
  disableOpenTelemetry?: boolean
}

type CreateCommClientLogger = (options: CommClientLogOptions) => Logger

const createCommClientLoggerOrDefault = async (
  logLevel: LogLevel
): Promise<Logger> => {
  const createCommClientLogger =
    await importSpecificExportMaybeUndefined<CreateCommClientLogger>(
      "createCommClientLogger"
    )
  if (createCommClientLogger) {
    return createCommClientLogger({ minLevel: logLevel })
  }
  return createLogger({ minLevel: logLevel })
}

const loadCommClient = createEffect({
  async handler(config: CommClientConfiguration) {
    const commClientLogger = await createCommClientLoggerOrDefault("info")
    updateBaseLogger(commClientLogger)
    await initUCS(config, {
      logger: commClientLogger,
    })
    return getSharedCommClient()
  },
})
export const commClientStore = createStore<ICommClient | null>(null).on(
  loadCommClient.done,
  (_, data) => data.result
)

export const useCommClient = (config?: CommClientConfiguration) => {
  const commClient = useStore(commClientStore)

  useEffect(() => {
    if (!commClient && config) {
      loadCommClient(config)
    }
  }, [commClient, config])

  return { commClient }
}
